import React, {Component} from 'react';

import { connect } from 'react-redux'
import LeadSources from './components/LeadSources/LeadSources'
import LeadSourcePromo from './components/LeadSources/LeadSourcePromo'

import {
  fetchSlimAccount, fetchLeadSources, fetchLeadSourceStats
} from 'broker/redux/account'

import { UNIVERSAL_EXPORT_TIMEFRAME_MONTH } from 'common/constants'
import {getAuthEmail} from "broker/util/downloader";

const mapDispatchToProps = dispatch => ({
    dispatch
})

class LeadSourcesContainer extends Component {

    constructor(props) {
      super(props)
    }

    componentWillMount() {
      this.props.dispatch(fetchSlimAccount())
      .then(response => {
        if(response.is_partner_brokerage) {
          this.props.dispatch(fetchLeadSourceStats(response.broker_hash))
        }
      })
      this.props.dispatch(fetchLeadSources(UNIVERSAL_EXPORT_TIMEFRAME_MONTH))
    }

    render() {
      const { account={} } = this.props
      return !account.broker_hash || _.isEmpty(account) ? null : (account.is_partner_brokerage) ? <LeadSources {...this.props} /> : <LeadSourcePromo {...this.props} />
    }
}

export default connect((state) => ({ account: state.account, inquiryModal: state.inquiryModal, email: getAuthEmail(state), auth: state.auth, root: state.root }), mapDispatchToProps)(LeadSourcesContainer)
